import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { searchInventoryItemsForSupplier } from 'services';
import { showError } from 'utils';
import SearchBar from 'components/Autosuggest/Autosuggest';
import { Modal } from 'react-bootstrap';
import ActionButton from 'components/ActionButton';

const SelectInventoryItemModal = props => {
  const { selectedSupplier,onSelectedItem ,item,  setShowMatchInventoryItemModal, showMatchInventoryItemModal,
    fetchDefaultSuggestions: fetchDefaultSuggestionsFromProps } = props;
  const [selectedItem, setSelectedItem] = useState<any>({});
  const [name, setName] = useState(item.name);

  useEffect(() => {
    if (selectedSupplier.length) fetchDefaultSuggestions();
    if(name==='') setSelectedItem({});
  }, [selectedSupplier, item.name]);

  const [defaultSuggestions, setDefaultSuggestions] = useState<Record<string, any>[]>([]);

  const fetchDefaultSuggestions = async () => {
    if (fetchDefaultSuggestionsFromProps) {
      try {
        const suggestions = await fetchDefaultSuggestionsFromProps(selectedSupplier);
        setDefaultSuggestions(suggestions.map(suggestion => ({
          id: suggestion.inventoryItem?.objectId,
          displayName: suggestion.inventoryItem?.name,
          quantity: suggestion.inventoryItem?.lastQuantityOrdered || 1,
          cost: suggestion.cost,
          price: suggestion.inventoryItem?.price,
          supplierUnitMapping: suggestion.supplierUnit,
          producerUnitMapping: suggestion.inventoryItem?.unit?.description,
          category: {
            displayName: suggestion.inventoryItem?.category?.description,
          },
          image: suggestion.inventoryItem?.image?.url,
          inventoryNameForSupplier: suggestion.inventoryNameForSupplier,
        })));
      } catch (e) {
        showError(e);
      }
    }
  };

  return (
    <Modal show={showMatchInventoryItemModal} animation={false} size='lg' onHide={()=> setShowMatchInventoryItemModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Select Item To Match :{item.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SearchBar
          local={true}
          value={name}
          setValue={value => setName(value)}
          defaultSuggestions={defaultSuggestions}
          searchAPI={searchInventoryItemsForSupplier}
          searchAPIParam={selectedSupplier}
          onSuggestionClicked={setSelectedItem}
        />
      </Modal.Body>
      <Modal.Footer>
        <ActionButton
          active={selectedItem}
          isLoading={false}
          onClick={()=> {onSelectedItem(selectedItem)}}
          text={'Match Item'}          
        />
      </Modal.Footer>
    </Modal>
  );
};

export default SelectInventoryItemModal;
